import React, { useEffect, useState } from 'react';
import { InformeEntity } from '../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import SelectorSimple from '../../../../../shared/Components/Selectores/Simple';


export const SelectorInformes = (props:any) =>{

  let {data, onChange, disabled, conVersion, MostrarTODOS} = props;
  let [options, setOptions] = useState<any>(undefined)

  useEffect(()=>{
    if(data)
    {setOptions(getOptions())}
    if(data.length > 0 && !disabled) change(data[0].idTipoInforme)
    else if (disabled) change(undefined)
  },[data, disabled])
  
  const change = (value:any) =>{
    if(conVersion != undefined && conVersion){
      if(value == 'TODO'){
        onChange(data)
      }else{
        var vInforme = data.filter((x :InformeEntity) => x.idTipoInforme == value)[0];
        onChange(vInforme)
      }
    }else{
      onChange(value)
    }
  }

  const getOptions = () =>{
    var result = data.map((p: InformeEntity)=> { return { value: p.idTipoInforme, inputDisplay: p.tipoInforme } })
    if(conVersion != undefined && conVersion && MostrarTODOS != undefined && MostrarTODOS){
      result = [ ...result, ...[{value: 'TODO', inputDisplay: 'TODO'}]];
    }
    return result;
  }

  return (
    <SelectorSimple {...props} options={options} onChange={change} name="selectInformes"/>
  )
}
export default SelectorInformes